// extracted by mini-css-extract-plugin
module.exports = {"arrow":"CarouselArrow_arrow__4_jwm","next":"CarouselArrow_next__ogG4s","prev":"CarouselArrow_prev__NZ3uN","circleBorder":"CarouselArrow_circleBorder__Skj9K"};